var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1017 17.435L18.943 12.2763C18.693 12.0264 18.3539 11.8859 18.0003 11.8859C17.6468 11.8859 17.3077 12.0264 17.0577 12.2763L7.15366 22.1803C5.66476 20.9334 4.54454 19.3036 3.91382 17.4668C3.2831 15.63 3.16583 13.6559 3.57464 11.7573C3.98346 9.85875 4.90284 8.10783 6.23365 6.69339C7.56445 5.27895 9.25616 4.25468 11.1263 3.73105C12.9965 3.20742 14.9741 3.2043 16.8459 3.72203C18.7177 4.23976 20.4126 5.25869 21.7479 6.66892C23.0831 8.07916 24.008 9.82717 24.4228 11.7244C24.8376 13.6217 24.7266 15.5962 24.1017 17.435ZM14.0003 27.3337C21.3643 27.3337 27.3337 21.3643 27.3337 14.0003C27.3337 6.63633 21.3643 0.666992 14.0003 0.666992C6.63633 0.666992 0.666992 6.63633 0.666992 14.0003C0.666992 21.3643 6.63633 27.3337 14.0003 27.3337ZM12.667 11.3337C12.667 12.0409 12.386 12.7192 11.8859 13.2193C11.3858 13.7194 10.7076 14.0003 10.0003 14.0003C9.29308 14.0003 8.6148 13.7194 8.11471 13.2193C7.61461 12.7192 7.33366 12.0409 7.33366 11.3337C7.33366 10.6264 7.61461 9.94814 8.11471 9.44804C8.6148 8.94794 9.29308 8.66699 10.0003 8.66699C10.7076 8.66699 11.3858 8.94794 11.8859 9.44804C12.386 9.94814 12.667 10.6264 12.667 11.3337Z",
    fill: "#ECEFF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessPicture);
export default __webpack_public_path__ + "static/media/business-picture.1f3c68b3053474d1b5e01248cf4557cb.svg";
export { ForwardRef as ReactComponent };